import { render, staticRenderFns } from "./Labels.vue?vue&type=template&id=4ae36028&scoped=true&functional=true&"
import script from "./Labels.vue?vue&type=script&lang=js&"
export * from "./Labels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "4ae36028",
  null
  
)

export default component.exports